<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="page_5">Abbreviations</a></h2><a id="page_5">
<p class="bib"><span class="bold">AAA</span> – Anti-aircraft artillery</p>
<p class="bib"><span class="bold">ABDACOM</span> – American-British-Dutch- Australian Command</p>
<p class="bib"><span class="bold">AIF</span> – Australian Imperial Force</p>
<p class="bib"><span class="bold">AT</span> – Anti-tank</p>
<p class="bib"><span class="bold">AWM</span> – Australian War Memorial</p>
<p class="bib"><span class="bold">C-in-C</span> – Commander-in-Chief</p>
<p class="bib"><span class="bold">COS</span> – Chief of Staff</p>
<p class="bib"><span class="bold">ETO</span> – European Theatre of Operations</p>
<p class="bib"><span class="bold">FEAF</span> – Far Eastern Air Force</p>
<p class="bib"><span class="bold">GOC</span> – General Officer Commanding</p>
<p class="bib"><span class="bold">HE</span> – High explosive</p>
<p class="bib"><span class="bold">HMG</span> – Heavy machine-gun</p>
<p class="bib"><span class="bold">HQ</span> – Headquarters</p>
<p class="bib"><span class="bold">IJA</span> – Imperial Japanese Army</p>
<p class="bib"><span class="bold">IJN</span> – Imperial Japanese Navy</p>
<p class="bib"><span class="bold">IR</span> – Infantry Regiment</p>
<p class="bib"><span class="bold">JCS</span> – Joint Chiefs of Staff</p>
<p class="bib"><span class="bold">LCVP</span> – Landing Craft Vehicle Personnel</p>
<p class="bib"><span class="bold">LMG</span> – Light machine-gun</p>
<p class="bib"><span class="bold">LOC</span> – Lines of communication</p>
<p class="bib"><span class="bold">MG</span> – Machine-gun</p>
<p class="bib"><span class="bold">MMG</span> – Medium machine-gun</p>
<p class="bib"><span class="bold">MT</span> – Motor Track</p>
<p class="bib"><span class="bold">NARA</span> – National Archives and Records Administration</p>
<p class="bib"><span class="bold">NEI</span> – Netherlands East Indies</p>
<p class="bib"><span class="bold">PIR</span> – Parachute Infantry Regiment</p>
<p class="bib"><span class="bold">POWs</span> – Prisoners-of-war</p>
<p class="bib"><span class="bold">PT</span> – Patrol torpedo</p>
<p class="bib"><span class="bold">QF</span> – Quick-firing</p>
<p class="bib"><span class="bold">RAAF</span> – Royal Australian Air Force</p>
<p class="bib"><span class="bold">RAN</span> – Royal Australian Navy</p>
<p class="bib"><span class="bold">RCT</span> – Regimental Combat Team</p>
<p class="bib"><span class="bold">RN</span> – Royal Navy</p>
<p class="bib"><span class="bold">SEAC</span> – South-East Asia Command</p>
<p class="bib"><span class="bold">SMG</span> – Submachine-gun</p>
<p class="bib"><span class="bold">SMLE</span> – Short Magazine Lee Enfield</p>
<p class="bib"><span class="bold">SNLF</span> – Special Naval Landing Force</p>
<p class="bib"><span class="bold">SWPA</span> – South-West Pacific Area</p>
<p class="bib"><span class="bold">TF</span> – Task Force</p>
<p class="bib"><span class="bold">USAAF</span> – United States Army Air Force</p>
<p class="bib"><span class="bold">USAFFE</span> – United States Army Forces in the Far East</p>
<p class="bib"><span class="bold">USAMHI</span> – United States Army Military History Institute</p>
<p class="bib"><span class="bold">USMC</span> – United States Marine Corps</p>
<p class="bib"><span class="bold">USN</span> – United States Navy</p>
</a><p class="bib"><a id="page_5"><span class="bold">USS</span> – US ship</a><a id="page_6"></a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Abbreviations.vue?f5f94624